function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "line top right",
  d: "M250.323,25.427l-15.362,-13.728l0,21.479l15.362,-7.751Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,49.791l27.234,-13.749l-7.931,-7.088l-19.303,9.743l0,11.094Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,66.403l39.108,-19.737l-7.933,-7.096l-31.175,15.739l0,11.094Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,83.017l50.98,-25.735l-7.931,-7.098l-43.049,21.739l0,11.094Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,99.631l62.857,-31.738l-7.931,-7.085l-54.926,27.729l0,11.094Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,116.245l74.734,-37.728l-7.936,-7.093l-66.798,33.727l0,11.094Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,132.859l86.608,-43.726l-7.931,-7.096l-78.677,39.728l0,11.094Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,149.473l98.48,-49.716l-7.931,-7.096l-90.549,45.718l0,11.094Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,166.087l110.357,-55.716l-7.934,-7.096l-102.423,51.718l0,11.094Z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,182.701l122.234,-61.717l-7.936,-7.085l-114.298,57.708l0,11.094Z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,199.313l134.108,-67.705l-7.931,-7.093l-126.177,63.704l0,11.094Z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,215.927l145.983,-73.703l-7.934,-7.095l-138.049,69.704l0,11.094Z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,232.541l157.854,-79.703l-7.931,-7.085l-149.923,75.694l0,11.094Z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,249.155l169.731,-85.693l-7.933,-7.096l-161.798,81.695l0,11.094Z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,265.769l181.608,-91.694l-7.936,-7.093l-173.672,87.693l0,11.094Z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,282.384l193.483,-97.685l-7.931,-7.093l-185.552,93.683l0,11.095Z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,298.998l205.354,-103.683l-7.931,-7.098l-197.423,99.686l0,11.095Z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  className: "line right",
  d: "M234.962,304.517l0,10.739l217.004,-109.526l-7.704,-6.887l-209.3,105.674Z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "line top left",
  d: "M230.037,33.216l0,-21.519l-15.379,13.749l15.379,7.77Z"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M210.716,28.975l-7.934,7.085l27.255,13.768l0,-11.102l-19.321,-9.751Z"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M198.841,39.59l-7.937,7.095l39.133,19.756l0,-11.103l-31.196,-15.748Z"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M186.963,50.204l-7.931,7.096l51.004,25.756l0,-11.105l-43.073,-21.747Z"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M175.088,60.827l-7.931,7.098l62.879,31.746l0,-11.107l-54.948,-27.737Z"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M163.216,71.442l-7.934,7.098l74.756,37.744l0,-11.105l-66.822,-33.737Z"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M151.341,82.066l-7.936,7.085l86.632,43.748l0,-11.108l-78.696,-39.725Z"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M139.463,92.681l-7.933,7.096l98.506,49.734l0,-11.105l-90.573,-45.725Z"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M127.589,103.296l-7.932,7.095l110.379,55.736l0,-11.105l-102.447,-51.726Z"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M115.714,113.918l-7.932,7.088l122.256,61.73l0,-11.102l-114.324,-57.716Z"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M103.841,124.533l-7.931,7.095l134.127,67.724l0,-11.102l-126.196,-63.717Z"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M91.966,135.147l-7.936,7.096l146.007,73.724l0,-11.105l-138.071,-69.715Z"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M80.089,145.772l-7.931,7.096l157.878,79.711l0,-11.104l-149.947,-75.703Z"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M68.214,156.384l-7.932,7.099l169.753,85.712l0,-11.105l-161.821,-81.706Z"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M56.341,167.009l-7.933,7.088l181.629,91.71l0,-11.105l-173.696,-87.693Z"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M44.466,177.624l-7.936,7.096l193.507,97.702l0,-11.104l-185.571,-93.694Z"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M230.037,287.931l-197.448,-99.692l-7.934,7.093l205.382,103.704l0,-11.105Z"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  className: "line left",
  d: "M20.714,198.864l-7.68,6.865l217.002,109.527l0,-10.711l-209.322,-105.681Z"
});

var SvgPyramid = function SvgPyramid(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    viewBox: "-80 -70 630 724",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPyramid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pyramid.ac3ba699.svg";
export { ForwardRef as ReactComponent };